import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '../../utils/baseQueryFn';

export const expensesApi = createApi({
  reducerPath: 'expensesApi',
  baseQuery,
  endpoints: (builder) => ({
    getExpenses: builder.query({
      query: ({ page, limit, search }) => {
        const queryParams = new URLSearchParams({
          page,
          limit,
        });

        if (search) {
          queryParams.append('search', search);
        }

        const apiUrl = `main/v1/petty-cash-reasons?${queryParams.toString()}`;

        return {
          url: apiUrl,
          method: 'GET',
        };
      },
      providesTags: ['expenses'],
      transformResponse: (response) => response,
    }),
    getExpensesById: builder.query({
      query: (id) => ({
        url: `main/v1/petty-cash-reasons/${id}`,
        method: 'GET',
      }),
      providesTags: ['expenses'],
      transformResponse: (response) => response,
    }),
    updateExpenses: builder.mutation({
      query: (body) => ({
        url: `main/v1/petty-cash-reasons/edit`,
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body,
      }),
      invalidatesTags: ['expenses'],
    }),
    createExpenses: builder.mutation({
      query: (body) => ({
        url: `main/v1/petty-cash-reasons/new`,
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body,
      }),
      invalidatesTags: ['expenses'],
    }),
    deleteExpenses: builder.mutation({
      query: (body) => ({
        url: `main/v1/petty-cash-reasons/delete`,
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body,
      }),
      invalidatesTags: ['expenses'],
    }),
  }),
});

export const {
  useGetExpensesQuery,
  useGetExpensesByIdQuery,
  useUpdateExpensesMutation,
  useCreateExpensesMutation,
  useDeleteExpensesMutation,
} = expensesApi;
